module.exports = __webpack_public_path__ + "img/step4.ace0007b.png";